import styled from "styled-components"
import { Link } from "gatsby"

const Wrapper = styled.header`
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);

  > div {
    align-items: center;
    display: flex;
    height: 55px;
    justify-content: space-between;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      height: 85px;
    }

    > div {
      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        flex: 0 0 auto;
        width: calc(100% / 3);
      }

      &:nth-child(1) {
        @media only screen and (max-width: calc(${props => props.theme.mq.small} - 1px)) {
          display: none;
        }
      }

      &:nth-child(3) {
        text-align: right;
      }
    }
  }
`

const Site = styled.a`
  font-size: 15px;
  font-weight: ${props => props.theme.title.w};
  transition: color 0.3s;

  .no-touchevents &:hover {
    color: ${props => props.theme.colors.primary};
  }
`

const Logo = styled(Link)`
  display: block;
  transition: opacity 0.3s;
  margin: 0 auto;
  height: auto;
  width: 150px;

  @media only screen and (min-width: ${props => props.theme.mq.small}) {
    width: 205px;
  }

  .no-touchevents &:hover {
    opacity: 0.7;
  }
`

const Burger = styled.button`
  text-align: right;

  .no-touchevents &:hover {
    span {
      background-color: ${props => props.theme.colors.primary};
    }
  }

  span {
    background-color: ${props => props.theme.colors.grey};
    display: block;
    height: 2px;
    transition: background-color 0.3s;
    width: 27px;

    @media only screen and (min-width: ${props => props.theme.mq.small}) {
      width: 33px;
    }

    &:not(:last-child) {
      margin-bottom: 6px;

      @media only screen and (min-width: ${props => props.theme.mq.small}) {
        margin-bottom: 8px;
      }
    }
  }
`

export const sHeader = {
  Wrapper,
  Site,
  Logo,
  Burger,
}
